import React, { useState, useEffect } from 'react';

import { makeStyles, Container, Grid, Paper, IconButton } from '@material-ui/core';
import BreadCrumb from 'app/components/BreadCrumb';
import CustomPaginationActionsTable from 'app/components/TableList/TableList';
import { injectIntl } from 'react-intl';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';

import { useDispatch, useSelector } from 'react-redux';
import { errorHandler } from 'app/utils/errorHandler';
import { setCompanyLines } from 'app/store/slices/company';

import ModalDocuments from 'app/components/ModalDocuments';

import styles from './styles';
import certificationEndpoints from '../../../api/services/certificationEndpoints';
import lineEndpoint from '../../../api/services/lineEndpoint';
import { usePersistentFilters } from '../../../internalPages/Lines/hooks/usePersistentFilters';
const useStyles = makeStyles(styles);

const LinkDocumento = ({ classes, content, openModal }) => {
  const handleClick = () => {
    openModal(content);
  };

  if (!content.documentos || content.documentos.length === 0) return <></>;
  return (
    <>
      <IconButton
        color="primary"
        className={classes.iconDocument}
        size="small"
        onClick={() => handleClick()}
      >
        <InsertDriveFileIcon className={classes.icon} />
      </IconButton>
    </>
  );
};

const LinesList = props => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({});
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [rows, setRows] = useState([]);


  const initialFilters = {
    campoOrdenacao: 'linha.nuLinha',
    direcaoOrdenacao: 'desc',
  };

  const [filters, setFilters] = usePersistentFilters(initialFilters);


  const [open, setOpen] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const [selectedLine, setSelectedLine] = useState({});

  const { intl } = props;

  const prepareData = content => {
    const isStrip = content.cdEmpresa;
    return {
      originalData: content,
      num_contrato: <>{isStrip ? content.nuTermoContrato : content.nuEdital }</>,
      cod_linha: <>{content.nuLinha}</>,
      nome_linha: <>{content.deDescricao}</>,
      document: (
        <LinkDocumento {...props} classes={classes} content={content} openModal={openModal} />
      ),
    };
  };

  const lines = useSelector(state => state.company.lines);

  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        const search = { page: page, size: pageSize, request: { ...filters } };
        const response = await lineEndpoint.getLines(search);
        const responseLines = [];
        if(!response || !response.data) return
        if(response.data?.content){
          for (const row of response.data.content) {
            const temp = {...row, documentos: []};
            const documents = await certificationEndpoints.getLineCertificates(row.cdLinha);
            if(documents.data){
              temp.documentos = documents.data.map(doc => {
                const tempDoc = {...doc};
                if(tempDoc.tipoDocumento){
                  tempDoc.date = tempDoc.dtEmissaoCrc;
                  tempDoc.fileName = tempDoc.tipoDocumento.nmTipoDocumento;
                  if(doc.numeroCrc && doc.cdLinhaApostila && doc.cdLinhaApostila !== ''){
                    tempDoc.fileName = `${tempDoc.fileName} ${doc.numeroCrc}`;
                  }
                }else{
                  tempDoc.idFile = tempDoc.idFileCrc;
                }
                return tempDoc;
              });
            }
            responseLines.push(temp);
          }
        }

        dispatch(setCompanyLines({...response.data, content: responseLines }));
      } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
      }
      setLoading(false);
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, filters, page, pageSize]);

  useEffect(() => {
    const rows = [];
    if (lines && lines.content) {
      lines.content.forEach(cont => {
        rows.push(prepareData(cont));
      });
    }
    setRows(rows);
    setPagination(lines);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lines]);

  const openModal = item => {
    setSelectedLine(item);
    setOpen(true);
  };

  const handleClose = () => {
    setSelectedLine({});
    setOpen(false);
  };

  const handleChangeFilter = (key, value) => {
    const temp = { ...filters };
    temp[key] = value;
    setFilters(temp);
  };

  const onChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const onChangeRowsPerPage = event => {
    setPageSize(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onBlurSearch = event => {
    handleChangeFilter('txtBusca', event.target.value);
    setPage(0);
  };

  const handleClickRow = (e, row) => {};

  const onChangeSearch = event => {};

  const columns = [
    { title: 'Linha', field: 'cod_linha', align: 'left' },
    { title: 'Contrato', field: 'num_contrato', align: 'left' },
    { title: 'Nome da linha', field: 'nome_linha', align: 'left' },
    { title: '', field: 'document', align: 'right' },
  ];

  const breadCrumb = [
    {
      title: intl.formatMessage({ id: 'LABELS.LINES.LINES' }),
      path: '',
    },
  ];

  return (
    <>
      <ModalDocuments
        title={`Documentos`}
        type="linhas"
        open={open}
        onClose={handleClose}
        data={selectedLine}
      />
      <Container>
        <BreadCrumb breadCrumb={breadCrumb} />
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper className={classes.container} elevation={3}>
              <CustomPaginationActionsTable
                loading={loading}
                columns={columns}
                rows={rows}
                placeholderSearch="Busca"
                pagination={pagination}
                onChangePage={onChangePage}
                onChangeRowsPerPage={onChangeRowsPerPage}
                onBlurSearch={onBlurSearch}
                onChangeSearch={onChangeSearch}
                onClickRow={handleClickRow}
                hideOrder={true}
                hideItemOrder={true}
                hideInitialDate={true}
                hideFinalDate={true}
              />
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default injectIntl(LinesList);
